// extracted by mini-css-extract-plugin
export default {"nameStepContainer":"Name_nameStepContainer__+lIcm","headline":"Name_headline__rYewZ","email":"Name_email__j9y0O","forms":"Name_forms__P5nmz","form":"Name_form__tgUKc"};